import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=5fb16fac&scoped=true&"
import script from "./Specialties.vue?vue&type=script&lang=js&"
export * from "./Specialties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb16fac",
  null
  
)

export default component.exports